import { createHook, createStore, defaults } from 'react-sweet-state';

// Integrate react-sweet-state with the redux dev tools.
defaults.devtools = true;

const TimeRangeHistoryStore = createStore({
    name: 'TimeRangeHistory',

    initialState: {
        history: [],
        canPanBack: false,
        canPanForward: false,
        canZoomIn: false,
        canZoomOut: false,
        canReset: false,
        lastTimeRange: undefined,
    },

    actions: {
        addHistoryItem: (newItem) => {
            return ({ getState, setState }) => {
                const state = getState();
                const history = [...state.history, newItem];
                setState({
                    history,
                    canReset: history.length > 1,
                });
            };
        },

        resetHistory: (initialHistory = []) => {
            return ({ setState }) => {
                setState({
                    history: initialHistory,
                    canReset: initialHistory.length > 1,
                });
            };
        },

        setCanPanBack: (canPanBack) => {
            return ({ setState }) => {
                setState({
                    canPanBack,
                });
            };
        },

        setCanPanForward: (canPanForward) => {
            return ({ setState }) => {
                setState({
                    canPanForward,
                });
            };
        },

        setCanZoomIn: (canZoomIn) => {
            return ({ setState }) => {
                setState({
                    canZoomIn,
                });
            };
        },

        setCanZoomOut: (canZoomOut) => {
            return ({ setState }) => {
                setState({
                    canZoomOut,
                });
            };
        },

        setLastTimeRange: (timeRange) => {
            return ({ setState }) => {
                setState({
                    lastTimeRange: timeRange,
                });
            };
        },
    },
});

export const useTimeRangeHistory = createHook(TimeRangeHistoryStore);

export const useHistory = createHook(TimeRangeHistoryStore, {
    selector: (state) => state.history,
});

export const useCanPanBack = createHook(TimeRangeHistoryStore, {
    selector: (state) => state.canPanBack,
});

export const useCanPanForward = createHook(TimeRangeHistoryStore, {
    selector: (state) => state.canPanForward,
});

export const useCanZoomIn = createHook(TimeRangeHistoryStore, {
    selector: (state) => state.canZoomIn,
});

export const useCanZoomOut = createHook(TimeRangeHistoryStore, {
    selector: (state) => state.canZoomOut,
});

export const useCanReset = createHook(TimeRangeHistoryStore, {
    selector: (state) => state.canReset,
});

export const useLastTimeRange = createHook(TimeRangeHistoryStore, {
    selector: (state) => state.lastTimeRange,
});
